import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

import * as S from './Item.styles';

type ItemProps = {
  name: string;
};

const defaultProps: Partial<ItemProps> = {};

export function Item(props: ItemProps): React.ReactElement {
  const { name } = { ...defaultProps, ...props };

  return (
    <S.Container>
      {name ? <Headline>{name}</Headline> : null}

      <Button iconLeft="FiUnlock" motive="add" />
    </S.Container>
  );
}
